import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import BankBalancePage from "./pages/BankBalancePage";
import PurchaseInvoicesPage from "./pages/PurchaseInvoicesPage";
import SalesInvoicesPage from "./pages/SalesInvoicesPage";
import SalariesPage from "./pages/SalariesPage";
import ManagementFeesPage from "./pages/ManagementFeesPage";
import TaxesPage from "./pages/TaxesPage";
import RevenueForecastPage from "./pages/RevenueForecastPage";
import RepaymentsPage from "./pages/RepaymentsPage";
import CashflowPage from "./pages/CashflowPage";
import SettingsPage from "./pages/SettingsPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import AcceptInvitePage from "./pages/AcceptInvitePage";

// AppRouter handles session_id detection synchronously during render
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  // This must be synchronous to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      
      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <Navigate to="/cashflow" replace />
        </ProtectedRoute>
      } />
      
      <Route path="/cashflow" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><CashflowPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/bank-balance" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><BankBalancePage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/purchase-invoices" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><PurchaseInvoicesPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/sales-invoices" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><SalesInvoicesPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/taxes" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><TaxesPage /></main>
        </ProtectedRoute>
      } />
      <Route path="/taxes/:yearParam" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><TaxesPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/salaries" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><SalariesPage /></main>
        </ProtectedRoute>
      } />
      <Route path="/salaries/:yearParam" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><SalariesPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/management-fees" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><ManagementFeesPage /></main>
        </ProtectedRoute>
      } />
      <Route path="/management-fees/:yearParam" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><ManagementFeesPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/repayments" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><RepaymentsPage /></main>
        </ProtectedRoute>
      } />
      <Route path="/repayments/:yearParam" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><RepaymentsPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/revenue-forecast" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><RevenueForecastPage /></main>
        </ProtectedRoute>
      } />
      <Route path="/revenue-forecast/:yearParam" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><RevenueForecastPage /></main>
        </ProtectedRoute>
      } />
      
      <Route path="/settings" element={
        <ProtectedRoute>
          <Navigation />
          <main className="ml-64"><SettingsPage /></main>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
